// Aweri video bubble (sections/aweri-video-bubble.liquid): tap the bubble -> the video plays in a full-screen
// panel on the shared AweriModal contract; closing removes the player so audio always stops. The bubble's x tucks
// it off the left edge behind a small pull-out tab, remembered for the browser session. If the shopper is already on
// the button's page, the button just closes the panel.
(function () {
  var KEY = 'aweri-vbubble-tucked';
  // Session storage can throw (private mode / blocked cookies). Then the tucked state just isn't remembered across
  // pages - tucking and the tab still work on the page; it never breaks the site.
  function remembered() { try { return !!sessionStorage.getItem(KEY); } catch (e) { return false; } }
  function remember(on) {
    try { if (on) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); return true; } catch (e) { return false; }
  }
  function init(root) {
    if (root.dataset.vbReady) return;
    root.dataset.vbReady = '1';
    var name = 'video-bubble-' + root.getAttribute('data-aweri-vbubble');
    var openBtn = root.querySelector('[data-vb-open]');
    var panel = root.querySelector('[data-vb-panel]');
    var overlay = root.querySelector('[data-vb-overlay]');
    var frame = root.querySelector('[data-vb-frame]');
    var tpl = root.querySelector('[data-vb-player]');
    var cta = root.querySelector('[data-vb-cta]');
    var closeBtn = root.querySelector('[data-vb-close]');

    var xBtn = root.querySelector('[data-vb-dismiss]');
    var tab = root.querySelector('[data-vb-tab]');
    // Tucked = the badge + its x slide off the left edge and the tab slides in; only one side is focusable.
    function tuck(on, moveFocus) {
      root.classList.toggle('is-tucked', on);
      [openBtn, xBtn].forEach(function (el) { el.tabIndex = on ? -1 : 0; el.setAttribute('aria-hidden', on ? 'true' : 'false'); });
      tab.tabIndex = on ? 0 : -1;
      tab.setAttribute('aria-hidden', on ? 'false' : 'true');
      remember(on);
      if (moveFocus) (on ? tab : openBtn).focus();
    }
    if (remembered()) {
      // restore without the slide so a tucked bubble does not animate away on every page load
      root.classList.add('vb-instant');
      tuck(true, false);
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('vb-instant'); }); });
    }
    xBtn.addEventListener('click', function () { tuck(true, true); });
    tab.addEventListener('click', function () { tuck(false, true); });

    function hide() {
      panel.hidden = true;
      var player = frame.querySelector('video, iframe');
      if (player) player.remove();
    }

    openBtn.addEventListener('click', function () {
      if (!window.AweriModal) return;
      frame.appendChild(tpl.content.firstElementChild.cloneNode(true));
      panel.hidden = false;
      // Sound on: the shopper's tap allows audio, so start unmuted inside this click (a muted attribute from the
      // video_tag or the browser would otherwise win). YouTube embeds start muted on some browsers, so once the
      // player loads we ask it to unmute + play via its postMessage API (needs enablejsapi=1 in the src).
      var v = frame.querySelector('video');
      if (v) {
        v.muted = false;
        v.removeAttribute('muted');
        v.play().catch(function () { v.controls = true; });
      }
      var yt = frame.querySelector('iframe[data-vb-youtube]');
      // ponytail: the YouTube player can ignore commands until it has booted, so resend a few times instead of
      // loading the full IFrame API script; the upgrade path is that API's onReady if this ever proves flaky.
      if (yt) yt.addEventListener('load', function () {
        [0, 700, 1600].forEach(function (ms) {
          setTimeout(function () {
            if (!yt.contentWindow) return;
            ['unMute', 'playVideo'].forEach(function (cmd) {
              yt.contentWindow.postMessage(JSON.stringify({ event: 'command', func: cmd, args: [] }), 'https://www.youtube-nocookie.com');
            });
          }, ms);
        });
      });
      AweriModal.open(name, { panel: panel, overlay: overlay, opener: openBtn, initialFocus: closeBtn, onClose: hide });
    });

    closeBtn.addEventListener('click', function () { AweriModal.close(name); });

    if (cta) cta.addEventListener('click', function (e) {
      if (cta.pathname === location.pathname) { e.preventDefault(); AweriModal.close(name); }
    });
  }
  document.querySelectorAll('[data-aweri-vbubble]').forEach(init);
  // Theme editor only: a re-rendered section brings fresh markup, so bind it again.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-aweri-vbubble]');
    if (root) init(root);
  });
})();
